import script from "./SubMenuCollection.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubMenuCollection.vue?vue&type=script&lang=ts&setup=true"

import "./SubMenuCollection.vue?vue&type=style&index=0&id=4802ada8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4802ada8"]])

export default __exports__